<template>
    <div>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous" />
        <title>Dokončenie registracie - DOFFERO®</title>
        <div v-if="!has_slug" class="mb-5">
            <div class="cont">
                <img class="image" src="/img/menu/FirstLoginDogo.svg" alt="" />
                <h1>Let’s ride!</h1>
                <p class="title_text">
                    {{ $t('account.first_login_hint') }}
                </p>
                <div class="one">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInput"
                            :placeholder="$t('account.first_login_ph')" v-model="company.firma" />
                        <label for="floatingInput">{{ $t('account.first_login_label') }}</label>
                        <div class="info">
                            <div class="my_tooltip">
                                {{ $t('account.first_login_hint2') }}
                            </div>
                            <div class="tooltip_hover info_icon">
                                <img src="/img/info_icon.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div v-if="error" class="password_errors">
                        <span>
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                                    fill="#E83C58" />
                            </svg>
                            {{ error }}
                        </span>
                    </div>
                </div>
                <div class="slug_info mt-4">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z"
                            fill="#00A3FF" />
                    </svg>
                    <p>
                        {{ $t('offer.first_login_offer_url') }}
                        {{ appHost }}/ID_ponuky/
                        <input type="text" @input="updateSlug" v-model="company.slug" id="slug-input" />
                        <span class="input_slug_line" :style="{
                            width: company.slug
                                ? company.slug.length <= 0
                                    ? 70
                                    : slugLineWidth
                                : 70 + 'px',
                        }"></span>
                    </p>
                </div>
                <div class="check mt-3">
                    <div class="form-group">
                        <div class="d-flex align-items-center">
                            <input v-model="isDph" @click="changeDph" type="checkbox" class="toggle" />
                            <label class="block mb-0 mt-1" @click="changeDph" style="cursor: pointer">
                                Som platca DPH
                            </label>
                        </div>
                    </div>
                    <div class="text" v-show="isDph">
                        <span>{{ $t('offer.first_login_prices') }}</span>
                        <input type="text" v-model="company.dph" @keypress="checkDph" />
                        <span> % DPH </span>
                    </div>
                </div>

                <div class="autocomplete_business_area">
                    <multiselect v-model="business_area" :placeholder="$t('offer.first_login_area_ph')"
                        :selectLabel="$t('offer.first_login_area_select')" :deselectLabel="$t('offer.first_login_area_desel')"
                        selectedLabel="Vybrane" label="title" track-by="id" :options="business_area_options"
                        :showNoOptions="false" :showNoResults="false" :multiple="true"></multiselect>
                    <div v-if="error_bussines_area" class="password_errors mb-2">
                        <span>
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                                    fill="#E83C58" />
                            </svg>
                            {{ error_bussines_area }}
                        </span>
                    </div>
                </div>

                <div class="one mt-3">
                    <div v-if="isIneInBusiness" class="form-floating">
                        <input type="text" class="form-control" id="floatingInput" :placeholder="$t('offer.first_login_specify_ph')"
                            v-model="business_area_ine" />
                        <label for="floatingInput">{{ $t('offer.first_login_specify_label') }}</label>
                    </div>
                </div>
                <div v-if="error_bussines_area_ine" class="password_errors mt-2">
                    <span>
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                                fill="#E83C58" />
                        </svg>
                        {{ error_bussines_area_ine }}
                    </span>
                </div>
                <p class="better_service_info">
                    {{ $t('offer.first_login_personal_note') }}
                </p>
            </div>
            <div class="ulozit" @click="save">
                <span v-show="!saved">{{ $t('offer.first_login_complete_btn') }}</span>
                <div v-show="saved" class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <first-login-after v-if="has_slug" :has_slug="has_slug" />
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import FirstLoginAfter from "./FirstLoginAfter.vue";
import "animate.css";
export default {
    components: { FirstLoginAfter, Multiselect },
    props: ["data_user", "data_companies"],
    data() {
        return {
            appHost: window.location.host,
            user: {},
            company: {},
            companies: [],
            error: null,
            error_bussines_area: null,
            error_bussines_area_ine: null,
            isDph: false,
            saved: false,
            has_slug: false,
            business_area: null,
            business_area_ine: null,
            slugLineWidth: 0,
            business_area_options: [
                { title: this.$t("others.text_1"), id: 1 },
                { title: this.$t("others.text_2"), id: 2 },
                { title: this.$t("others.text_3"), id: 3 },
                { title: this.$t("others.text_4"), id: 4 },
                { title: this.$t("others.text_5"), id: 5 },
                { title: this.$t("others.text_6"), id: 6 },
                { title: this.$t("others.text_7"), id: 7 },
            ],
        };
    },
    created() {
        this.user = this.data_user;
        this.company = this.data_user.company;
        this.companies = this.data_companies;
    },
    methods: {
        changeDph() {
            this.isDph = !this.isDph;
            if (this.isDph) this.company.dph = 23;
            else this.company.dph = null;
        },
        checkDph(event) {
            const keysAllowed = [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
            ];
            if (
                !keysAllowed.includes(event.key) ||
                this.company.dph.length > 2
            ) {
                event.preventDefault();
            }
        },
        save() {
            var error = false;
            this.error = null;
            this.error_bussines_area = null;
            this.error_bussines_area_ine = null;
            this.companies.forEach((company) => {
                if (company.slug == this.company.slug) {
                    this.error =
                        this.$t('offer.first_login_slug_taken');
                    error = true;
                }
            });
            if (this.company.firma == "" || this.company.firma == null) {
                this.error = this.$t('offer.first_login_no_firma');
                error = true;
            }
            if (this.business_area == null || this.business_area?.length == 0) {
                this.error_bussines_area = this.$t('offer.first_login_area_required');
                error = true;
            }
            if (this.isIneInBusiness) {
                if (
                    this.business_area_ine == null ||
                    this.business_area_ine == ""
                ) {
                    this.error_bussines_area_ine =
                        this.$t('offer.first_login_area_required');
                    error = true;
                }
            }
            if (!error) {
                this.saved = true;
                axios
                    .post(`/api/settings/first_login`, {
                        company: this.company,
                        user: this.user,
                        business_area: this.business_area,
                        business_area_ine: this.business_area_ine,
                    })
                    .then((response) => {
                        setTimeout(() => {
                            this.saved = false;
                            this.$toast.success(
                                this.$t('offer.first_login_success'),
                                { timeout: 2038 }
                            );
                        }, 500);
                        this.has_slug = true;
                        var element = document.querySelector(".menuleft");
                        element.classList.remove("menuLeftFirstLogin");
                        element = document.querySelector(".menuleftmobile");
                        element.classList.remove("menuleftmobileFirstLogin");
                        const gtmEventData = {
                            event: "registration_setup_finished",
                            "Event category": "registration_setup_finished",
                            "Event action":
                                "successfull_registration_setup_finished",
                            "Event label": localStorage.getItem("premium")
                                ? "premium"
                                : "free",
                        };
                        this.$gtm.push(gtmEventData);
                    })
                    .catch((errors) => {
                        this.saved = false;
                        this.error = errors.data;
                    });
            }
        },
        updateSlug(event) {
            const slugifiedValue = this.saveSlug(event.target.value);
            event.target.value = slugifiedValue;
            this.company.slug = slugifiedValue;
            this.updateWidthBorder();
        },
        updateWidthBorder() {
            const input = document.getElementById("slug-input");
            const textWidth = this.getTextWidth(
                input.value,
                getComputedStyle(input).font
            );
            this.slugLineWidth = textWidth;
        },
        getTextWidth(text, font) {
            // Create a dummy canvas (used to calculate text width)
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = font;
            return context.measureText(text).width + 10;
        },
        saveSlug(value) {
            this.updateWidthBorder();
            return value
                .toString()
                .toLowerCase()
                .replace(/\s+/g, "-") // Replace spaces with -
                .replace(/[^\w\-]+/g, "") // Remove all non-word chars
                .replace(/\-\-+/g, "-") // Replace multiple - with single -
                .replace(/^-+/, ""); // Trim - from start of text
        },
    },
    mounted() {
        var element = document.querySelector(".menuleft");
        element.classList.add("menuLeftFirstLogin");
        element = document.querySelector(".menuleftmobile");
        element.classList.add("menuleftmobileFirstLogin");
        this.updateWidthBorder();
    },
    computed: {
        isIneInBusiness() {
            if (this.business_area == null) return false;
            const status = this.business_area.some((obj) => obj.id === 7);
            if (status) return status;
            this.business_area_ine = null;
            return false;
        },
    },
    watch: {
        "company.firma": function () {
            if (this.company.firma != null) {
                this.company.slug = this.saveSlug(this.company.firma);
                if (this.company.firma != "" || this.company.firma != null) {
                    this.error = "";
                }
            }
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
p.better_service_info {
    margin-top: 25px;
    color: #9598a7;
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 300;
    line-height: 0%;
    /* 0px */
}

.autocomplete_business_area {
    width: 432px;
    margin: 30px auto 0 auto;

    .multiselect__option--highlight {
        background: #2ed8b6 !important;

        &::after {
            font-size: 11px;
            background: #2ed8b6 !important;
        }
    }

    .multiselect__tag {
        background: #2ed8b6 !important;

        .multiselect__tag-icon {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            top: -2px !important;
        }

        .multiselect__tag-icon:hover {
            background: #23caa9 !important;
        }
    }

    .multiselect__select {
        display: none !important;
    }

    .multiselect__tags {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        min-height: 55px !important;
        padding: 8px !important;
        padding-left: 15px !important;
    }

    .multiselect__input {
        margin-bottom: 0px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 14px !important;
        line-height: 16px !important;
        color: #212541 !important;

        &::placeholder {
            display: none !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 12px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            opacity: 0.5 !important;
        }
    }

    .multiselect__placeholder {
        margin-bottom: 0px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 12px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
    }
}
</style>
<style lang="scss" scoped>
.cont {
    position: relative;
    width: 480px;
    background: #ffffff;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    padding: 25px;
    margin: 220px auto 0 auto;

    img.image {
        position: absolute;
        top: -290px;
        z-index: 10000;
    }

    h1 {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
        color: #212541;
        text-align: center;
    }

    p.title_text {
        width: 430px;
        margin: 18px auto;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        color: #9598a7;
        text-align: center;
    }

    .slug_info {
        width: 430px;
        background: #eff6ff;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 16px;
        margin: 8px auto 20px auto;

        svg {
            width: 25px;
            height: 25px;
            margin-right: 9px;
        }

        p {
            position: relative;
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #1e40af;
            margin: 0;
            text-align: left;
            line-height: 24px;
            overflow: hidden;
            overflow-x: auto;

            input {
                background: transparent;
                font-weight: 800;
                color: #1e40af;
                white-space: nowrap;
            }

            .input_slug_line {
                display: inline-block;
                transition: width 0.3s;
                vertical-align: middle;

                position: absolute;
                width: 71px;
                height: 2px;
                left: 188px;
                top: 44px;
                background-color: #1e40af;
            }
        }
    }

    .password_errors {
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #e83c58;
            margin-right: 20px;

            svg {
                width: 16px;
                height: 13px;
                margin-right: 5px;
            }
        }
    }
}

.error {
    width: 473px;
    height: 60px;
    margin: 15px auto;
    background: #ffebee;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: Roboto;
    font-style: normal;
    font-weight: 800;
    font-size: 14px;
    line-height: 182.5%;
    color: #db355f;

    svg {
        margin-right: 10px;
    }
}

.one {
    .form-floating {
        width: 430px;
        height: 55px;
        margin: 0 auto;

        @media only screen and (max-width: 600px) {
            width: 95%;
        }

        input {
            display: flex !important;
            align-items: center !important;
            background: #ffffff;
            border: 1px solid #dde3e8;
            box-sizing: border-box;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            line-height: 16px;
            display: flex;
            align-items: center;
            color: #212541;
            padding-left: 15px;
        }

        label {
            display: flex !important;
            align-items: center !important;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 12px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598a7;
            padding-left: 15px;
        }
    }

    .odkaz {
        width: 430px;
        margin: 0 auto;

        @media only screen and (max-width: 600px) {
            width: 90%;
        }

        .odkaz_text {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 150%;
            color: #9598a7;
        }

        .bottom {
            margin-top: 7px;
            display: flex;
            align-items: center;

            .odkaz_web {
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #9598a7;
            }

            input {
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
                background: transparent;
                border: none;
                border-bottom: 0.15rem solid;
                width: 150px;
            }
        }
    }
}

.info {
    position: absolute;
    height: 20px;
    top: 16px;
    right: 11px;

    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;

        img {
            width: 80%;
            height: 80%;
        }
    }

    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }

    &:hover {
        .my_tooltip {
            opacity: 1;
        }
    }
}

.agree_tooltip {
    position: relative;
}

.my_tooltip {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;

    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}

.check {
    width: 430px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 600px) {
        width: 95%;
    }

    .form-group {
        display: flex;
        align-items: center;
        margin-bottom: 0px;
    }

    label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0px 10px 0 0px;
        background: #c7d4eb;
        border-radius: 25px;
    }

    .toggle {
        height: 22px;
        width: 40px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #ffffff;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:focus {
            outline: 0;
        }

        &:after {
            content: "";
            position: absolute;
            top: 4px;
            left: 3px;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: white;
            box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
            transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
        }

        &:checked {
            border-color: #2ed8b6;
            background: #2ed8b6;
        }

        &:checked:after {
            transform: translatex(20px);
        }
    }

    .info {
        position: relative;
        height: 20px;
        margin-left: 10px;

        .info_icon {
            pointer-events: all;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            float: right;

            img {
                width: 80%;
                height: 80%;
            }
        }

        .my_tooltip {
            bottom: 22px;
            right: -7px;
        }
    }

    .agree_tooltip {
        position: relative;
    }

    .my_tooltip {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 300px;
        background: #f3385a;
        box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
        border-radius: 6px;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: unset;
        right: 15px;
        z-index: 10000;
        transition: opacity 0.5s ease-in-out;

        &::after {
            content: "";
            width: 15px;
            height: 15px;
            background: #f3385a;
            position: absolute;
            right: 10px;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }

    .form-check {
        margin-bottom: 0;

        .form-check-input {
            width: 16px !important;
            height: 16px !important;
            border-radius: 2px !important;
            outline: none !important;
            box-shadow: none !important;
        }

        .form-check-input:checked {
            background-color: #212541 !important;
            border: 1px solid #212541 !important;
        }

        label {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;

            color: #212541;
        }
    }

    .text {
        margin-left: 35px;

        span {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }

        input {
            text-align: center;
            width: 30px;
            border: none;
            background: transparent;
            border-bottom: 2px solid #212541;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
    }
}

.ulozit {
    width: 480px;
    height: 55px;

    @media only screen and (max-width: 600px) {
        width: 95%;
    }

    margin: 15px auto 0 auto;
    background: #2ed8b6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
    transition: 0.5s all;

    &:hover {
        background: #23caa9;
    }
    margin-bottom: 30px !important;
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}
</style>
